/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Finals_Table_UnfinishedInputs */



/**
* | output |
* | --- |
* | "Finals table must be Finished first" |
*
* @param {Err_Tournament_Finals_Table_UnfinishedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_finals_table_unfinished = /** @type {((inputs?: Err_Tournament_Finals_Table_UnfinishedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Finals_Table_UnfinishedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("La table de finale doit d'abord être terminée")
	if (locale === "es") return /** @type {LocalizedString} */ ("La mesa de finales debe estar finalizada primero")
	if (locale === "pt") return /** @type {LocalizedString} */ ("A mesa final deve ser Finalizada primeiro")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il tavolo finale deve essere prima Concluso")
	return /** @type {LocalizedString} */ ("Finals table must be Finished first")
});